import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { allStyles } from './FormStyles';
import { translate } from './FormUtils';

const styles = StyleSheet.create(allStyles);

export default function TitleLabel(props) {
    let title = '';

    if (Array.isArray(props.title)) {
        title = translate(props.title);
    } else if (typeof props.title === 'string') {
        title = props.title;
    } 

    return (
        <View style={{flexDirection:'row'}}>
            {props.icon &&
            <Image style={{width:16, height:16, marginTop:5, marginRight:5}} resizeMode={'contain'} source={props.icon}/>
            }
            <Text style={styles.title}>
                {title}
                {(props.required && !props.hideStar) && 
                <Text style={styles.red}>{'*'}</Text>
                }
                <Text>{': '}</Text>
                {(props.error && !props.hideError) &&
                <Text style={styles.red}>{props.error}</Text>
                }
                {(props.tip) &&
                <Text style={styles.tip}>{props.tip}</Text>
                }
            </Text>
        </View>
        
    )
}